// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.LoadingSplash_loadingSplash__e5aqH {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0f172a; /* slate-900 — premium enterprise dark */
  z-index: 9999;
}

.LoadingSplash_content__1IE-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.LoadingSplash_logo__duVle {
  width: 120px;
  height: auto;
  animation: LoadingSplash_logoBreath__Oe1do 3s ease-in-out infinite;
}
.LoadingSplash_logo__duVle img,
.LoadingSplash_logo__duVle svg {
  width: 100%;
  height: auto;
}

.LoadingSplash_logoIcon__yf2MQ {
  /* White logo via invert + subtle teal glow */
  filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));
}

.LoadingSplash_spinner__TRfrz {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(15, 191, 160, 0.2);
  border-top-color: #0FBFA0;
  border-radius: 50%;
  animation: LoadingSplash_spin__88XMV 1s linear infinite;
}

.LoadingSplash_loadingText__BeajW {
  color: #cbd5e1; /* slate-300 */
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  letter-spacing: 0.025em;
  animation: LoadingSplash_fadeInOut__kS692 2s ease-in-out infinite;
}

/* Subtle floating teal particles */
.LoadingSplash_particles__Xw6KA {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.LoadingSplash_particle__U8kAt {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(15, 191, 160, 0.4);
  animation: LoadingSplash_float__twRBR 8s ease-in-out infinite;
}
.LoadingSplash_particle__U8kAt:nth-child(1) {
  top: 20%;
  left: 15%;
  animation-delay: -2s;
}
.LoadingSplash_particle__U8kAt:nth-child(2) {
  top: 60%;
  right: 20%;
  animation-delay: -5s;
}
.LoadingSplash_particle__U8kAt:nth-child(3) {
  top: 30%;
  right: 30%;
  animation-delay: -7s;
}

@keyframes LoadingSplash_spin__88XMV {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes LoadingSplash_logoBreath__Oe1do {
  0%, 100% {
    transform: scale(1);
    filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));
  }
  50% {
    transform: scale(1.02);
    filter: brightness(0) invert(1) drop-shadow(0 0 32px rgba(15, 191, 160, 0.4));
  }
}
@keyframes LoadingSplash_fadeInOut__kS692 {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
@keyframes LoadingSplash_float__twRBR {
  0%, 100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.4;
  }
  25% {
    transform: translateY(-20px) translateX(10px) scale(1.1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-10px) translateX(-15px) scale(0.9);
    opacity: 0.8;
  }
  75% {
    transform: translateY(-30px) translateX(5px) scale(1.05);
    opacity: 0.5;
  }
}
/* RTL Support */
[dir=rtl] .LoadingSplash_loadingSplash__e5aqH {
  direction: rtl;
}

/* Accessibility: reduced motion */
@media (prefers-reduced-motion: reduce) {
  .LoadingSplash_logo__duVle {
    animation: none;
    filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));
  }
  .LoadingSplash_spinner__TRfrz {
    animation: none;
    border-color: #0FBFA0;
    border-top-color: #0FBFA0;
  }
  .LoadingSplash_loadingText__BeajW {
    animation: none;
  }
  .LoadingSplash_particle__U8kAt {
    animation: none;
    opacity: 0.2;
  }
}
/* Accessibility: high contrast */
@media (prefers-contrast: high) {
  .LoadingSplash_loadingSplash__e5aqH {
    background: #000000;
  }
  .LoadingSplash_loadingText__BeajW {
    color: #ffffff;
  }
  .LoadingSplash_spinner__TRfrz {
    border-color: #ffffff;
    border-top-color: #0FBFA0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LoadingSplash/LoadingSplash.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,kEAAA;AAEF;AAAE;;EAEE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,6CAAA;EACA,6EAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,uDAAA;AACF;;AAEA;EACE,cAAA,EAAA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,iEAAA;AACF;;AAEA,mCAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,6DAAA;AACF;AACE;EACE,QAAA;EACA,SAAA;EACA,oBAAA;AACJ;AAEE;EACE,QAAA;EACA,UAAA;EACA,oBAAA;AAAJ;AAGE;EACE,QAAA;EACA,UAAA;EACA,oBAAA;AADJ;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE;IACE,mBAAA;IACA,6EAAA;EAHF;EAKA;IACE,sBAAA;IACA,6EAAA;EAHF;AACF;AAMA;EACE;IACE,YAAA;EAJF;EAMA;IACE,UAAA;EAJF;AACF;AAOA;EACE;IACE,+CAAA;IACA,YAAA;EALF;EAOA;IACE,wDAAA;IACA,YAAA;EALF;EAOA;IACE,yDAAA;IACA,YAAA;EALF;EAOA;IACE,wDAAA;IACA,YAAA;EALF;AACF;AAQA,gBAAA;AACA;EACE,cAAA;AANF;;AASA,kCAAA;AACA;EACE;IACE,eAAA;IACA,6EAAA;EANF;EASA;IACE,eAAA;IACA,qBAAA;IACA,yBAAA;EAPF;EAUA;IACE,eAAA;EARF;EAWA;IACE,eAAA;IACA,YAAA;EATF;AACF;AAYA,iCAAA;AACA;EACE;IACE,mBAAA;EAVF;EAaA;IACE,cAAA;EAXF;EAcA;IACE,qBAAA;IACA,yBAAA;EAZF;AACF","sourcesContent":[".loadingSplash {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #0f172a; /* slate-900 — premium enterprise dark */\n  z-index: 9999;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\n\n.logo {\n  width: 120px;\n  height: auto;\n  animation: logoBreath 3s ease-in-out infinite;\n\n  img,\n  svg {\n    width: 100%;\n    height: auto;\n  }\n}\n\n.logoIcon {\n  /* White logo via invert + subtle teal glow */\n  filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 2px solid rgba(15, 191, 160, 0.2);\n  border-top-color: #0FBFA0;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.loadingText {\n  color: #cbd5e1; /* slate-300 */\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n  letter-spacing: 0.025em;\n  animation: fadeInOut 2s ease-in-out infinite;\n}\n\n/* Subtle floating teal particles */\n.particles {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.particle {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: rgba(15, 191, 160, 0.4);\n  animation: float 8s ease-in-out infinite;\n\n  &:nth-child(1) {\n    top: 20%;\n    left: 15%;\n    animation-delay: -2s;\n  }\n\n  &:nth-child(2) {\n    top: 60%;\n    right: 20%;\n    animation-delay: -5s;\n  }\n\n  &:nth-child(3) {\n    top: 30%;\n    right: 30%;\n    animation-delay: -7s;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes logoBreath {\n  0%, 100% {\n    transform: scale(1);\n    filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));\n  }\n  50% {\n    transform: scale(1.02);\n    filter: brightness(0) invert(1) drop-shadow(0 0 32px rgba(15, 191, 160, 0.4));\n  }\n}\n\n@keyframes fadeInOut {\n  0%, 100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) translateX(0) scale(1);\n    opacity: 0.4;\n  }\n  25% {\n    transform: translateY(-20px) translateX(10px) scale(1.1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: translateY(-10px) translateX(-15px) scale(0.9);\n    opacity: 0.8;\n  }\n  75% {\n    transform: translateY(-30px) translateX(5px) scale(1.05);\n    opacity: 0.5;\n  }\n}\n\n/* RTL Support */\n[dir=\"rtl\"] .loadingSplash {\n  direction: rtl;\n}\n\n/* Accessibility: reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .logo {\n    animation: none;\n    filter: brightness(0) invert(1) drop-shadow(0 0 24px rgba(15, 191, 160, 0.3));\n  }\n\n  .spinner {\n    animation: none;\n    border-color: #0FBFA0;\n    border-top-color: #0FBFA0;\n  }\n\n  .loadingText {\n    animation: none;\n  }\n\n  .particle {\n    animation: none;\n    opacity: 0.2;\n  }\n}\n\n/* Accessibility: high contrast */\n@media (prefers-contrast: high) {\n  .loadingSplash {\n    background: #000000;\n  }\n\n  .loadingText {\n    color: #ffffff;\n  }\n\n  .spinner {\n    border-color: #ffffff;\n    border-top-color: #0FBFA0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSplash": `LoadingSplash_loadingSplash__e5aqH`,
	"content": `LoadingSplash_content__1IE-7`,
	"logo": `LoadingSplash_logo__duVle`,
	"logoBreath": `LoadingSplash_logoBreath__Oe1do`,
	"logoIcon": `LoadingSplash_logoIcon__yf2MQ`,
	"spinner": `LoadingSplash_spinner__TRfrz`,
	"spin": `LoadingSplash_spin__88XMV`,
	"loadingText": `LoadingSplash_loadingText__BeajW`,
	"fadeInOut": `LoadingSplash_fadeInOut__kS692`,
	"particles": `LoadingSplash_particles__Xw6KA`,
	"particle": `LoadingSplash_particle__U8kAt`,
	"float": `LoadingSplash_float__twRBR`
};
export default ___CSS_LOADER_EXPORT___;
